'use client'
import { QueryParamsWrapper } from '@/components/organisms/QueryParamsWrapper'
import { dispatchGTMEvent, GTM_EVENT_CATEGORY } from '@/helpers/gtm'
import { buildUrlWithParams, isAbsoluteUrl } from '@/helpers/url'
import { Button } from '@dynamo-caffeina-dev/airc-ui-kit'
import { ButtonProps } from '@/types'

const DONATION_URL = 'https://donazione.airc.it/'
const DEFAULT_PARAMS = `?ets_cmmk=5322&ets_sgmt=41440`
const DEFAULT_CONTENT = 'Dona ora'

/**
 * DonationButton component that handles UTM parameters
 * If href is provided and is absolute, it will append UTM params
 * If no href is provided, uses default donation URL with params
 */
const DonationButton = (props: ButtonProps) => {
  const { gtmZone } = props

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    dispatchGTMEvent(GTM_EVENT_CATEGORY.DONATION, {
      section: gtmZone ?? '',
    })
    if (props.onClick) props.onClick(event)
  }
  return (
    <QueryParamsWrapper>
      {(params) => {
        let ctaLink = props.href || DONATION_URL

        if (isAbsoluteUrl(props.href) || !props.href) {
          ctaLink = buildUrlWithParams(ctaLink, params, DEFAULT_PARAMS)
        }

        const { gtmZone: _, ...buttonProps } = props
        return (
          <Button
            {...buttonProps}
            className='donation-button'
            target='_blank'
            href={ctaLink}
            variant={'themed'}
            onClick={handleClick}
          >
            {props.content || DEFAULT_CONTENT}
          </Button>
        )
      }}
    </QueryParamsWrapper>
  )
}

export default DonationButton
